import React from 'react';
import { getTokenFromLocalStorage } from '../utils/helper';
import { Navigate, Outlet } from 'react-router-dom';
import { link } from '../constants/appConstants';

const PublicRoutes = () => {
  const token = getTokenFromLocalStorage();

  return <>{token ? <Navigate to={link.dashboard} /> : <Outlet />}</>;
};

export default PublicRoutes;
